import { matchPath } from 'react-router';
import { RoutePaths } from 'constant';

export const matchForPath = (
  paths: Array<string>,
  pathname: string,
): boolean => {
  return paths.some(
    (path: string) =>
      matchPath(pathname, {
        path,
        exact: true,
      }) !== null,
  );
};

export const matchForProjectPlanDetails = (path: string): boolean => {
  return matchForPath([RoutePaths.projectPlan, RoutePaths.projectDetail], path);
};

export const matchForTimesheets = (path: string): boolean => {
  return matchForPath(
    [
      RoutePaths.timesheets,
      RoutePaths.myTimesheets,
      RoutePaths.timesheetsApproval,
    ],
    path,
  );
};

export const matchForProjectTasksList = (path: string): boolean => {
  return matchForPath([RoutePaths.projectTaskList], path);
};

export const matchForProjectTasks = (path: string): boolean => {
  return matchForPath([RoutePaths.tasks], path);
};

export const matchForTimesheetReports = (path: string): boolean => {
  return matchForPath([RoutePaths.timesheetReports], path);
};

export const matchForTimesheetSingleUserApprovals = (path: string): boolean => {
  return matchForPath([RoutePaths.timesheetSingleUserApproval], path);
};

export const matchForResourceManagement = (path: string): boolean => {
  return matchForPath([RoutePaths.resourceManagement], path);
};

export const matchForProjectOverview = (path: string): boolean => {
  return matchForPath([RoutePaths.projectOverview], path);
};

export const matchForCreateNewProjectModal = (path: string): boolean => {
  return matchForPath([RoutePaths.projectCreate], path);
};
